<template>
    <div class="tools-tab tools-tab-shift">
        <ul class="list list-shifts">
            <li v-for="shift in activeShifts" @click="select(shift)">
                <em>{{ shift.identifier }}</em>
                <span>{{ shift.name }}</span>
                <icon name="add" />
            </li>
        </ul>
        <div class="empty" v-if="! shifts.length">
            {{ $t('page.settings.shifts.empty') }}
        </div>
    </div>
</template>

<script>
import events from '../../../events/events';
import shared from '../../../pages/planning/shared';

export default
{
    name: 'NewShift',

    props: ['date'],

    data() {
        return {
            shared: shared.state,
        }
    },

    computed:
    {
        activeShifts()
        {
            // TODO: might need to add legacy shift as well, if previously assigned!
            return _.filter(this.shared.shifts, {trashed: false});
        },

        shifts()
        {
            return _.sortBy(this.shared.shifts, ['name']);
        },
    },

    methods:
    {
        select(shift)
        {
            let item =
            {
                assigned: false,
                duty: null,
                shift: shift.id,
            };

            events.$emit('items.add', item, this.date);
        },
    }
}
</script>



// WEBPACK FOOTER //
// NewShift.vue?dac000b6